// src/services/visitorAnalyticsServices.js

import axios from "axios";

const apiUrl =
  `${process.env.REACT_APP_API_URL}/api/visitor-tracking`;

function getAuthHeaders() {
  const token =
    localStorage.getItem("token");

  if (!token) {
    return {};
  }

  return {
    Authorization: `Bearer ${token}`,
  };
}

function handleServiceError(
  message,
  error,
) {
  console.error(message, error);

  if (error?.response?.data) {
    console.error(
      "Réponse API :",
      error.response.data,
    );
  }

  throw error;
}

/**
 * Récupère toutes les statistiques analytiques
 * du centre visiteurs.
 *
 * Paramètres disponibles :
 * - range : 7d, 30d, 90d, 180d ou 365d ;
 * - date_from : YYYY-MM-DD ;
 * - date_to : YYYY-MM-DD ;
 * - exclude_bots : true ou false.
 */
export const getVisitorAnalytics =
  async (params = {}) => {
    try {
      const response =
        await axios.get(
          `${apiUrl}/analytics`,
          {
            headers:
              getAuthHeaders(),

            params,
          },
        );

      return response.data;
    } catch (error) {
      return handleServiceError(
        "Erreur lors de la récupération des statistiques analytiques :",
        error,
      );
    }
  };